import { useEffect, useState } from 'react'

/**
 * A value as it is once somebody has stopped changing it.
 *
 * For a search box: typing "Lakova" is six keystrokes and should be one
 * request, not six. The value comes back unchanged after `wait` milliseconds
 * of quiet, and every keystroke before that restarts the clock.
 */
export function useSettled<T>(value: T, wait = 200): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), wait)
    return () => clearTimeout(timer)
  }, [value, wait])

  return settled
}
